var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.2222C22.5 20.7567 21.2567 22 19.7222 22H5.27778C3.74389 22 2.5 20.7567 2.5 19.2222V4.77778C2.5 3.24333 3.74389 2 5.27778 2H19.7222C21.2567 2 22.5 3.24333 22.5 4.77778V19.2222Z",
    fill: "#3F51B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 12.72H16.3333V20H13.625V12.72H12V10.48H13.625V9.1304C13.6261 7.16592 14.4153 6 16.654 6H18.5V8.24H17.2612C16.3897 8.24 16.3333 8.576 16.3333 9.20488V10.48H18.5L18.1577 12.72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e8a298c8296aabd1e34a828f60e4dfd0.svg";
export { ForwardRef as ReactComponent };